import { baixarModeloPlanilha, lerPlanilha } from "./importacaoPlanilha";

/** Colunas da planilha de usuários da distribuidora. */
export const COLUNAS_IMPORTACAO_USUARIOS = [
	{ campo: "nome", rotulo: "Nome", obrigatorio: true, apelidos: ["nome", "nomecompleto", "usuario", "nomeusuario", "nomedousuario", "funcionario", "colaborador"] },
	{ campo: "email", rotulo: "E-mail", obrigatorio: true, apelidos: ["email", "emails"] },
	{ campo: "telefone", rotulo: "Telefone", obrigatorio: true, apelidos: ["telefone", "celular", "whatsapp", "fone", "contato"] },
	{
		campo: "dataNascimento",
		rotulo: "Data de nascimento",
		obrigatorio: true,
		apelidos: ["datanascimento", "datadenascimento", "nascimento", "dtnascimento", "dtnasc", "datanasc"],
	},
	{ campo: "unidades", rotulo: "Unidades", apelidos: ["unidades", "unidade", "unidadesdistribuidoras", "unidadedistribuidora", "filial", "filiais"] },
];

export function lerPlanilhaUsuarios(file) {
	return lerPlanilha(file, COLUNAS_IMPORTACAO_USUARIOS, { exemploCabecalho: "Nome, E-mail, Telefone, Data de nascimento", entidade: "usuário" });
}

export function baixarModeloImportacaoUsuarios() {
	baixarModeloPlanilha({
		colunas: COLUNAS_IMPORTACAO_USUARIOS,
		exemplo: ["Maria Souza", "maria.souza@empresa.com.br", "(11) 99999-8888", "10/05/1990", ""],
		instrucoes: [
			["Como preencher a planilha de usuários"],
			[],
			["Obrigatórios", "Nome, E-mail, Telefone e Data de nascimento."],
			["E-mail", "É por ele que o usuário recebe login e senha. Usuário com e-mail já cadastrado na empresa não é duplicado nem alterado."],
			["Telefone", "Celular com DDD (11 números), com ou sem pontuação."],
			["Data de nascimento", "No formato dd/mm/aaaa. Só é possível cadastrar usuários com 18 anos ou mais."],
			["Unidades", "Opcional. Nomes das unidades separados por ponto e vírgula, como estão no sistema. Vazio = a unidade aberta na tela."],
			["Licença", "A importação respeita a quantidade de usuários da licença: as linhas que passarem do limite não entram."],
		],
		aba: "Usuários",
		arquivo: "modelo-importacao-usuarios.xlsx",
	});
}
